import styled, { css } from "styled-components";
import { theme } from "../../theme/toyotaTheme";

export const Panel = styled.div<{ isActive?: boolean }>`
    margin: ${theme.space[2]}px 0;
    padding: ${theme.space[2]}px;
    font-size: 1.3rem;
    ${({ isActive }) => css`
        background: ${isActive ? theme.colors.primaryWhite : theme.colors.grey1};
        ${isActive &&
        css`
            position: relative;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            &:after {
                display: block;
                position: absolute;
                bottom: -25px;
                left: 0;
                width: 100%;
                height: 25px;
                content: "";
                background: ${theme.colors.primaryWhite};
            }
        `};
    `};
`;

export const Outline = styled.div`
    margin: ${theme.space[2]}px 0;
    padding: ${theme.space[2]}px;
    font-size: 1.3rem;
    border: 1px solid #adafb1;
`;

export const PanelIconWrapper = styled.span`
    margin-right: ${theme.space[1]}px;
`;
